import Vue from 'vue';

import rootInstance from './main';

const _app = new Vue(rootInstance);
